/* eslint-disable import/prefer-default-export */
import {
  misundestoodMaterialsReducer, mumQuizReducer,
  recyclingFundamentalsReducer, rfQuizReducer
} from '../pages/Quiz/helpers';

export const modifyQuizData = ({
  rf_quiz,
  rf_lessons,
  misunderstood_materials_quiz,
  misunderstood_materials
}) => {
  const quizData = {
    rfQuiz: Object.values(rf_quiz).length > 0 ? rfQuizReducer(
      rf_quiz,
      recyclingFundamentalsReducer(rf_lessons)
    ) : {},
    mumQuiz: Object.values(misunderstood_materials_quiz).length > 0 ? mumQuizReducer(
      misunderstood_materials_quiz,
      misundestoodMaterialsReducer(misunderstood_materials)
    ) : {}
  };

  return quizData;
};
